export const PAGE_SIZE = 20
export const MAX_FILE_SIZE = 1 * 1024 * 1024

export const CALLBACK_URL_KEY = 'callbackUrl'

export * from './layout'
